import React from "react";
import {Button, ButtonGroup, Glyphicon, Table} from "react-bootstrap";

export default ({members, onSelect, onCreate, onDelete}) => {
    const handleCreate = async () => {
        await onCreate();
    }

    const handleDelete = async (member) => {
        if (!confirm('Вы действительно хотите удалить участника трансляции?')) {
            return;
        }

        await onDelete(member.id);
    }

    return (
        <Table>
            <thead>
            <tr>
                <th style={{width: 40}}>ID</th>
                <th>ФИО</th>
                <th style={{width: 100}}></th>
            </tr>
            </thead>
            <tbody>
            {members.map((member) => (
                <tr key={member.id}>
                    <td>{member.id}</td>
                    <td>{member.fullnameRu}</td>
                    <td style={{textAlign: 'right'}}>
                        <ButtonGroup>
                            <Button onClick={() => onSelect(member)} bsSize="small"><Glyphicon glyph="edit" /></Button>
                            <Button onClick={() => handleDelete(member)} bsSize="small" bsStyle="danger"><Glyphicon glyph="trash" /></Button>
                        </ButtonGroup>
                    </td>
                </tr>
            ))}
            </tbody>
            <tfoot>
            <tr>
                <td colSpan={10}>
                    <Button onClick={handleCreate}>Добавить</Button>
                </td>
            </tr>
            </tfoot>
        </Table>
    );
}
